import { render, staticRenderFns } from "./datasource-transfer-minimization-status.vue?vue&type=template&id=00f3a75f"
import script from "./datasource-transfer-minimization-status.vue?vue&type=script&lang=js"
export * from "./datasource-transfer-minimization-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports